var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { getSingleFieldStyles } from './SingleFieldStyles';
import { Chart, DonutGraph } from '@airtel/air-design-system';
import { LineChartLegend } from '../custom-legends/LineChartLegend';
export var SingleField = props => {
  var graphType = props.graphType,
    graphData = props.graphData;
  var _useState = useState(graphData),
    graphDataState = _useState[0],
    setGraphDataState = _useState[1];
  var singleFieldStyles = getSingleFieldStyles();
  useEffect(() => {
    setGraphDataState(graphData);
  }, [JSON.stringify(graphData)]);
  if (!graphDataState) return null;
  var customTooltipTitle = graphData.customTooltipTitle,
    customTooltipLabel = graphData.customTooltipLabel,
    customTooltipFooter = graphData.customTooltipFooter;
  var renderCustomTooltipTitle = context => {
    var _a;
    var _ref = (_a = context === null || context === void 0 ? void 0 : context[0]) !== null && _a !== void 0 ? _a : {},
      formattedValue = _ref.formattedValue,
      label = _ref.label;
    return customTooltipTitle.replace('${formattedValue}', formattedValue).replace('${label}', label);
  };
  var renderCustomTooltipLabel = context => {
    var _ref2 = context !== null && context !== void 0 ? context : {},
      formattedValue = _ref2.formattedValue,
      label = _ref2.label;
    return customTooltipLabel.replace('${formattedValue}', formattedValue).replace('${label}', label);
  };
  var renderCustomTooltipFooter = context => {
    var _context$ = context[0],
      formattedValue = _context$.formattedValue,
      label = _context$.label;
    return customTooltipFooter.replace('${formattedValue}', formattedValue).replace('${label}', label);
  };
  var getGraph = graphType => {
    switch (graphType) {
      case 'DONUT':
        return _jsx(DonutGraph, Object.assign({}, graphData));
      case 'line':
        {
          var chartData = graphDataState.chartData,
            restData = __rest(graphDataState, ["chartData"]);
          return _jsx(Chart, Object.assign({
            type: graphType,
            data: chartData
          }, restData, {
            showCustomLegend: true,
            legendPosition: "bottom",
            renderCustomLegend: () => _jsx(LineChartLegend, Object.assign({
              setChartData: setGraphDataState,
              chartData: graphDataState.chartData
            }, props))
          }));
        }
      case 'bar':
      case 'doughnut':
        {
          var _chartData = graphData.chartData,
            showCustomTootip = graphData.showCustomTootip,
            _restData = __rest(graphData, ["chartData", "showCustomTootip"]);
          return _jsx(Chart, Object.assign({
            type: graphType,
            data: _chartData
          }, _restData, {
            hideScale: graphType === 'doughnut',
            showCustomTootip: showCustomTootip,
            renderCustomTooltipTitle: customTooltipTitle ? renderCustomTooltipTitle : () => null,
            renderCustomTooltipLabel: customTooltipLabel ? renderCustomTooltipLabel : () => null,
            renderCustomTooltipFooter: customTooltipFooter ? renderCustomTooltipFooter : () => null
          }));
        }
      default:
        return null;
    }
  };
  return _jsx(View, Object.assign({
    style: singleFieldStyles.graphContainer
  }, {
    children: getGraph(graphType)
  }));
};